export default __webpack_public_path__ + "static/image5-40252583759b4c5c5d556d8edac2dc3b.jpeg";